import { joinInfoSegments } from '@orcar/common-d2c';
import { useBusinessProfile } from '@/hooks/useSiteProfile';
import * as S from '../styles';

const CompanyInfoSection = () => {
  const profile = useBusinessProfile();
  const lines = [
    joinInfoSegments([
      profile.tradeName && { text: profile.tradeName },
      profile.registrationNumber && {
        text: `사업자등록번호 : ${profile.registrationNumber}`,
      },
      profile.representative && { text: `대표 : ${profile.representative}` },
    ]),
    joinInfoSegments([
      profile.mailOrderNumber && {
        text: `통신판매신고 : ${profile.mailOrderNumber}`,
      },
      profile.address && { text: `주소: ${profile.address}` },
    ]),
    joinInfoSegments([
      profile.phone && { text: `상담문의전화 : ${profile.phone}` },
      profile.email && { text: `email : ${profile.email}` },
    ]),
  ];
  return (
    <S.CompanyInfoSectionWrapper>
      {lines.map(
        (line, index) =>
          line && <S.InfoContent key={index}>{line}</S.InfoContent>,
      )}
    </S.CompanyInfoSectionWrapper>
  );
};

export default CompanyInfoSection;
